import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Button, FormControl, Grid, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';

import { RootState } from '../../../reducers';
import { gotoNextMenu, gotoPreviousMenu, setAssessmentError, setAssessmentSuccess } from '../../../store/assessment.slice';
import { saveEngagementDraft } from '../../../store/documentEngagement.slice';
import { copyObject } from '../../../utils/common';
import AssessmentsCalendar from '../../Calendar/AssessmentsCalendar/AssessmentsCalendar';
import { DocumentEngagement } from '../../../Models/DocumentEngagements/DocumentEngagement.model';
import InfoIcon from '@mui/icons-material/Info';
import HelpPage from '../../../assets/documents/Assessment_Set_Appointment_Info.pdf';

const SetAppointment: React.FC<{ memberId: string }> = ({ memberId }) => {
    const dispatch = useAppDispatch();
    const { engagementDraft, memberAssessmentHistory } = useSelector((state: RootState) => state.documentEngagement);

    const handleOnSelectAppointmentDate = (params) => {
        if (!Boolean(params.appointmentId) || params.appointmentId.includes('_')) {
            dispatch(setAssessmentError({ Show: true, Message: `Unable to set Engagement date. Please wait for appointment to save and try again.` }));
        } else {
            let data = copyObject(engagementDraft) as DocumentEngagement;
            data.VisitedTime = new Date(params.date).toISOString();
            data.AssociatedAppointmentId = params.appointmentId;

            // Auto-populate MeansOfEngagement from appointment if not already set on the draft
            if (!Boolean(data.MeansOfEngagement) && Boolean(params.meansOfEngagement)) {
                data.MeansOfEngagement = params.meansOfEngagement;
            }

            const updatedMemberAssessmentHistory = { ...memberAssessmentHistory, EngagementDraft: data };
            dispatch(saveEngagementDraft(updatedMemberAssessmentHistory));

            dispatch(
                setAssessmentSuccess({
                    Show: true,
                    Message: 'Engagement date and time set. This will not reflect on other calendars until assessment is finished.',
                })
            );
        }
    };

    return (
        <Grid container direction="column" spacing={2} className="content-panel">
            <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ ml: 1 }}>
                <Typography variant="h6">Set Appointment Info</Typography>
                <Tooltip title="Set Appointment Help Document">
                    <InfoIcon color="primary" fontSize="small" cursor="pointer" onClick={() => window.open(`${HelpPage}`, '_blank')} />
                </Tooltip>
            </Stack>
            <Grid size={{ sm: 12, md: 12, lg: 12 }} sx={{ ml: 1, mb: 4 }}>
                <FormControl className="form-control-200">
                    <DesktopDatePicker
                        label="Engagement Date"
                        disabled
                        value={Boolean(engagementDraft) && Boolean(engagementDraft.VisitedTime) ? new Date(engagementDraft.VisitedTime) : null}
                        format="dd-MMM-yyyy"
                        minDate={new Date('2017-01-01')}
                        onChange={() => {}}
                        slotProps={{ textField: { fullWidth: true, size: 'small' } }}
                    />
                </FormControl>
            </Grid>
            <Grid className="content-form">{<AssessmentsCalendar memberId={memberId} onSelectAppointmentDate={handleOnSelectAppointmentDate} />}</Grid>
            <Grid justifyContent="flex-end" className="content-footer">
                <Button
                    type="submit"
                    variant="contained"
                    color="secondary"
                    sx={{ mr: 3 }}
                    onClick={() => dispatch(gotoPreviousMenu())}
                    startIcon={<ArrowBackIosIcon />}
                >
                    Previous
                </Button>
                <Button
                    type="submit"
                    variant="contained"
                    endIcon={<ArrowForwardIosIcon />}
                    disabled={!Boolean(engagementDraft?.VisitedTime)}
                    onClick={() => dispatch(gotoNextMenu())}
                >
                    Next
                </Button>
            </Grid>
        </Grid>
    );
};

export default SetAppointment;
